function hex2rgb(hex, opacity) {
  var h = hex.replace('#', '');
  h = h.match(new RegExp('(.{' + h.length / 3 + '})', 'g'));

  for (var i = 0; i < h.length; i++)
    h[i] = parseInt(h[i].length === 1 ? h[i] + h[i] : h[i], 16);

  if (typeof opacity != 'undefined') h.push(opacity);

  return 'rgba(' + h.join(',') + ')';
}

const Theme = {
  Colors: {
    cream: '#FFF5E1',
    blue: '#001F57',
    orange: '#FF773E',
    grey: '#707070',
    alphaMod: function (val, opacity) {
      return hex2rgb(val, opacity);
    }
  },
  Site: {
    defaultTitle: "The Smithy | Crafting branded content and experiences together",
    description: "The Smithy is a creative collective based in New England that takes pride in crafting branded content and experiences from the ground up. Let us collaborate with you to take your business to the next level.",
  }
};

export default Theme





